// TEMP STOP-GAP (#802) — foxbox stamps a ride's venue wall-clock as "wall + 8h"
// mislabeled `Z`. FVD's tblRide.dtmTime is a TIME-OF-DAY anchored to the 1899
// OLE epoch date, and 1899 has no DST, so the PowerShell bridge serializes it at
// the venue's STANDARD offset (PST, -8) year-round. composeRideTime then copies
// those UTC getters straight into a `Z` timestamp. Rendering that in the show's
// REAL offset gives the right time in winter (-8 matches) but is +1h all summer
// (-7). Since the baked offset is always -8, we recover the true instant by
// decoding at a fixed -8 to get the naive wall clock, then reinterpreting it in
// the venue zone. Fixes DISPLAY and the countdown/now-next epoch math at once.
//
// REMOVE THIS FILE when foxbox emits genuine UTC (#802 part B): stored values
// become correct and this correction would then re-break them by an hour.
const VENUE_TZ = "America/Los_Angeles";
const EIGHT_HOURS_MS = 8 * 60 * 60 * 1000;

// Venue-zone UTC offset (ms) at a given instant — DST-aware via Intl.
function venueOffsetMs(instantMs) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: VENUE_TZ,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(instantMs);
  const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
  const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  return asUtc - instantMs;
}

// "wall+8 mislabeled Z" -> genuine UTC ISO. Pass-through for empty/non-ISO.
export function foxboxTimeToUtc(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(String(iso))) return iso;
  const stamped = new Date(iso).getTime();
  if (Number.isNaN(stamped)) return iso;
  const wallMs = stamped - EIGHT_HOURS_MS; // naive venue wall clock, as if UTC
  const off = venueOffsetMs(wallMs); // venue offset for that wall date (DST-aware)
  return new Date(wallMs - off).toISOString();
}

export default foxboxTimeToUtc;
